import { z } from 'zod';
import { AuthTokens, AuthenticatedUser } from './auth.js';
/**
 * Vào tổ chức khác lần đầu: giữ hay xoá "tổ chức chỉ có mình tôi" — APM-PSPACE-n,
 * docs/plan-personal-space.md §0.4.
 *
 * Khi một người đang sống ở tổ chức cá nhân thành nhân sự của tổ chức khác, nhà dời sang tổ chức
 * ấy (`replacePersonalHome`) và **không** gì bị xoá; thay vào đó có một câu hỏi chờ trả lời. Chỉ
 * hỏi một lần trong đời tài khoản; sau đó muốn xoá thì có nút ở Cài đặt tài khoản (cùng lệnh).
 */
/** Một dự án sẽ mất nếu chọn "Xoá" — đủ để hộp xác nhận liệt kê được. */
export const PersonalOrgProject = z.object({
    id: z.uuid(),
    key: z.string(),
    name: z.string(),
});
/** Câu hỏi đang chờ — `GET /auth/me` → `personalOrgPrompt`. */
export const PersonalOrgPrompt = z.object({
    /** Tổ chức vừa vào. Giao diện chỉ hỏi khi phiên đang mở ở **đúng** tổ chức này. */
    orgId: z.uuid(),
    orgName: z.string(),
    personalOrgId: z.uuid(),
    /** Dự án còn sống trong tổ chức cá nhân — rỗng là trạng thái hợp lệ ("Không có dự án nào"). */
    projects: z.array(PersonalOrgProject),
});
/**
 * Phản hồi của `GET /auth/me`: người dùng của phiên + câu hỏi đang chờ (nếu có).
 *
 * Tách khỏi `AuthenticatedUser` vì `AuthenticatedUser` còn nằm trong `AuthTokens` và claim của
 * access token; câu hỏi là thứ chỉ `/auth/me` đọc.
 */
export const AuthMe = AuthenticatedUser.extend({
    personalOrgPrompt: PersonalOrgPrompt.nullable(),
});
export const PersonalOrgDecision = z.enum(['keep', 'delete']);
/** `POST /me/personal-org/decision`. */
export const PersonalOrgDecisionInput = z.object({ decision: PersonalOrgDecision });
export const PersonalOrgDecisionResult = z.object({
    /**
     * Phiên mới ở nhà — chỉ khi phiên đang mở **trong** tổ chức cá nhân vừa xoá (bấm từ Cài đặt
     * tài khoản lúc đang đứng ở đó). Cookie refresh mới đã được đặt; giao diện nạp lại trang.
     * `null`: phiên hiện tại vẫn dùng được.
     */
    session: AuthTokens.nullable(),
});
/** `GET /me/personal-org` — cho nút "Xoá tổ chức chỉ có mình tôi" ở Cài đặt tài khoản. */
export const MyPersonalOrg = z.object({
    personalOrg: z
        .object({
        orgId: z.uuid(),
        projects: z.array(PersonalOrgProject),
        /**
         * Xoá được không: nhà phải ở tổ chức khác. Nhà còn là tổ chức cá nhân thì xoá nó là để tài
         * khoản không còn tổ chức nào (`user.org_id NOT NULL`).
         */
        deletable: z.boolean(),
    })
        .nullable(),
});
//# sourceMappingURL=personal-org-decision.js.map